import { BinderDraftStatus } from "@/models/binder.model";
import { SeverityService } from "@/services/app/severity.service";
import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { TagModule } from "primeng/tag";


@Component({
    selector: 'app-draft-status-column',
    template: `
    <div *ngFor="let status of value">
                <p-tag *ngIf="status" [value]="status.DraftStatus.statusName"
                [severity]="getSeverity(status.draftStatusId)"></p-tag>
              </div>
    `,
    standalone: true,
    imports: [
        TagModule,
        CommonModule
    ],
    styles: [
        `
        `
    ]
})

export class DraftStatusColumnComponent {
@Input() value: BinderDraftStatus[] = [];
statusService = inject(SeverityService);

getSeverity(statusId: number): "success" | "info" | "warn" | "danger" | "secondary" | "contrast" | undefined {
  return this.statusService.getDraftingStatus(statusId);
}
}